export default __webpack_public_path__ + "static/media/Chain of Akkaria.78cab291.jpg";